import { ProductCard, ProductCardProps } from "./ProductCard"

type Props = {
  products: ProductCardProps[]
}

export function ProductListAttachment({ products }: Props) {
  if (products.length === 0) return null

  return (
    <div className="flex gap-3 overflow-x-auto px-4 pb-1">
      {products.map((product) => (
        <ProductCard key={product.id} {...product} />
      ))}
    </div>
  )
}
